import {
  questionTypeMap,
  answerTypeMap,
  buttonTypeMap,
  hasButtonType,
} from "@/hooks/defMap";

// 20251107新增：检查关联题目是否应该激活
function checkRelationQuestionActivation(question, resultList, state, getters) {
  if (!question.titleConfig.hasRelationConf) {
    return true;
  }
  let relationConf = question.titleConfig.relationConf;
  let isAnd = relationConf.isAnd;
  let relationList = relationConf.list;
  let isActive = isAnd
    ? relationList.every((relationItem) => {
        return checkRelationItem(
          resultList,
          relationItem,
          isAnd,
          state,
          getters
        );
      })
    : relationList.some((relationItem) => {
        return checkRelationItem(
          resultList,
          relationItem,
          isAnd,
          state,
          getters
        );
      });
  return isActive;
}

// 检查关联条件项
function checkRelationItem(resultList, relationItem, isAnd, state, getters) {
  // 答案记录中关联题目的作答情况
  let targetResult = resultList.find(
    (resultItem) => resultItem.titleId === relationItem.titleId
  );
  if (!targetResult) {
    return false;
  }
  // 答案条件选项
  let relationItemAnswer = relationItem.answer;
  let relationQuestionType = getters.getQuestionTypeByQuestionId(
    relationItem.titleId
  );
  // 除了矩阵题,其他题该数组长度只会为1
  let isMatrix = ["matrixSingle", "matrixProgress"].includes(
    relationQuestionType
  );
  return isAnd
    ? relationItemAnswer.every((answerItem) => {
        // 每个答案选项数据都满足条件则为true， 除了矩阵题,其他题该数组长度只会为1
        return checkAnswerCondition(targetResult, answerItem, isMatrix, state);
      })
    : relationItemAnswer.some((answerItem) => {
        // 答案选项数据有一个满足条件则为true， 除了矩阵题,其他题该数组长度只会为1
        return checkAnswerCondition(targetResult, answerItem, isMatrix, state);
      });
}

// 检查答案条件
function checkAnswerCondition(targetResult, answerItem, isMatrix, state) {
  // 检查答案条件
  if (isMatrix) {
    // 拿到矩阵的行标题数组
    let rowConfigArray =
      state.questionList[targetResult.currentIndex]?.answerConfig
        ?.rowTitleArray;
    // 关联条件指定的行标题下标
    let answerItemRowIndex = rowConfigArray.findIndex(
      (item) => item.id === answerItem.rowId
    );
    // 关联条件指定的矩阵行所选的答案下标
    let answerItemChooseIndex =
      targetResult.matrixAnswerIndexArray[answerItemRowIndex];
    // 关联条件指定的矩阵行所选的答案id
    let answerItemChooseId =
      targetResult.answerConfigArray[answerItemChooseIndex]?.id;
    // 要求的id列表包含答案id
    return answerItem.chooseIds.includes(answerItemChooseId);
  }
  // 获取所选的答案数据数组
  let answerChooseOriginData = targetResult.answerConfigArray.filter(
    (item, index) => targetResult.chooseAnswerIndexArray.includes(index)
  );
  // 要求的选项包含答案id（满足或关系）
  return answerChooseOriginData.some((chooseItem) =>
    answerItem.chooseIds.includes(chooseItem.id)
  );
}

export const getters = {
  currentQuestion(state) {
    // 当前题目总配置
    if (state.currentIndex < 0) {
      return [];
    }
    return state.questionList[state.currentIndex];
  },
  relationQuestionList(state) {
    // 关联题型列表
    return state.questionList.filter(
      (item) => item.titleConfig.hasRelationConf
    );
  },
  currentTitleConfig(state, getters) {
    // 当前题目的规则配置
    return getters.currentQuestion?.titleConfig;
  },
  currentAnswerConfig(state, getters) {
    // 当前题目的选项配置
    return getters.currentQuestion?.answerConfig;
  },
  currentQuestionType(state, getters) {
    // 当前的题目类别
    return questionTypeMap[getters?.currentTitleConfig?.type];
  },
  showLimitCount(state, getters) {
    // 是否展示文字限制，仅填空题会显示
    if (getters.currentQuestionType !== "cloze") {
      return false;
    }
    const hasMaxLimit = +getters.currentAnswerConfig.maxCount > 0;
    const hasMinLimit = +getters.currentAnswerConfig.minCount >= 0;
    return hasMaxLimit && hasMinLimit;
  },
  getQuestionTypeByQuestionId: (state) => (questionId) => {
    // 根据questionId定位题目类型
    let targetQuestion = state.questionList.find(
      (item) => item.titleConfig.id === questionId
    );
    return questionTypeMap[targetQuestion.titleConfig.type];
  },
  getQuestionTypeByQuestionIndex: (state) => (questionIndex) => {
    // 根据question下标获取题目类型
    return questionTypeMap[state.questionList[questionIndex].titleConfig.type];
  },
  currentButtonType(state, getters) {
    // 题目按钮样式： 1： 数字   2：点赞
    return hasButtonType.includes(getters.currentQuestionType)
      ? buttonTypeMap[getters.currentAnswerConfig.buttonType]
      : "";
  },
  currentAnswerConfigArray(state, getters) {
    // 当前题目最终的选项数组
    let dataMap = {
      singleChoose: getters.currentAnswerConfig,
      multipleChoose: getters.currentAnswerConfig?.list,
      matrixSingle: getters.currentAnswerConfig?.chooseArray,
      matrixProgress: getters.currentAnswerConfig?.scoreArray,
      NPS: getters.currentAnswerConfig?.ids,
    };
    return dataMap[getters.currentQuestionType];
  },
  getTextByLangId: (state) => (langId) => {
    // 根据langId获取文本
    return state.translate[langId];
  },

  isMatrixType(state, getters) {
    // 是否为矩阵类型
    return (
      getters.currentQuestionType === "matrixSingle" ||
      getters.currentQuestionType === "matrixProgress"
    );
  },
  hasFinishCollect(state) {
    // 是否有结束信息收集题
    return state.finishConfig && Object.values(state.finishConfig).length > 0;
  },
  currentResultType(state, getters) {
    // 当前题目的问卷结果处理类型
    return answerTypeMap[getters?.currentQuestionType];
  },
  currentCommonResult(state, getters) {
    // 基础作答信息
    return {
      type: getters.currentTitleConfig.type,
      typeName: getters.currentQuestionType,
      cost: new Date() - state.enterQuestionTime,
      nextQuestionIndex: getters.nextQuestionIndex,
      questionKey: getters.currentTitleConfig.questionKey,
      currentIndex: state.currentIndex,
      titleId: getters.currentTitleConfig.id,
      chooseAnswerIndexArray: state.chooseAnswer,
      matrixAnswerIndexArray: state.matrixAnswer,
      matrixRowConfigArray: getters.currentAnswerConfig?.rowTitleArray,
      answerConfigArray: getters.currentAnswerConfigArray,
      resultType: getters.currentResultType,
    };
  },
  getQuestionIndexById: (state) => (id) => {
    // 根据Id获取题目下标
    if (+id === -1) return -1;
    let targetId = state.questionList.findIndex(
      (item) => item.titleConfig.id === id
    );
    return targetId === -1 ? state.currentIndex + 1 : targetId; // 未找到直接返回下一题
  },
  progressRatio(state) {
    // 顶部进度条计算
    // 剔除未激活关联题目的数目总数
    let ratio = ((state.currentIndex + 1) / state.questionList.length).toFixed(
      2
    );
    let percent = parseInt(ratio * 100);
    return (percent > 100 ? 100 : percent) + "%";
  },
  nextQuestionIndex(state, getters) {
    // 计算下一题下标
    const currentIndex = state.currentIndex;
    if (currentIndex === state.questionList.length - 1) {
      // 最后一题
      return -1;
    }
    let jumpType = getters.currentTitleConfig?.jumpType || 0;
    const jumpNextArray =
      // 0 不跳  1 按选项跳  2 无条件跳
      [
        () => currentIndex + 1,
        () =>
          getters.getQuestionIndexById(
            getters.currentAnswerConfigArray[state.chooseAnswer[0]]?.jumpId
          ),
        () => getters.getQuestionIndexById(getters.currentTitleConfig.jumpId),
      ];
    return jumpNextArray[jumpType]();
  },
  getValidQuestionIndex: (state, getters) => (questionIndex) => {
    // 过滤未激活的关联题目
    if (questionIndex === -1) {
      // 直接跳转结果页
      return -1;
    }

    // 添加深度限制，防止无限递归
    const maxDepth = state.questionList.length;
    let depth = 0;

    let currentIndex = questionIndex;
    while (depth < maxDepth) {
      let targetConfig = state.questionList[currentIndex]?.titleConfig;
      // 判断是否为关联题目
      if (!!targetConfig?.hasRelationConf && !targetConfig.relationActive) {
        // 下一题是关联题目且未激活，需要基于当前答案（包括未提交的）重新检查是否应该激活
        // 构建包含当前题目答案的临时resultList
        const tempResultList = [...state.resultList];
        // 如果当前题目有答案但还未提交，需要临时添加到resultList中
        // 检查当前题目是否有答案（选择题检查chooseAnswer，矩阵题检查matrixAnswer）
        const hasCurrentAnswer =
          state.currentIndex >= 0 &&
          (state.chooseAnswer.length > 0 || state.matrixAnswer.length > 0);
        if (hasCurrentAnswer) {
          const currentQuestion = state.questionList[state.currentIndex];
          const currentAnswerConfigArray = getters.currentAnswerConfigArray;
          const tempCurrentResult = {
            type: currentQuestion.titleConfig.type,
            typeName: getters.currentQuestionType,
            cost: 0,
            nextQuestionIndex: getters.nextQuestionIndex,
            questionKey: currentQuestion.titleConfig.questionKey,
            currentIndex: state.currentIndex,
            titleId: currentQuestion.titleConfig.id,
            chooseAnswerIndexArray: state.chooseAnswer || [],
            matrixAnswerIndexArray: state.matrixAnswer || [],
            matrixRowConfigArray: currentQuestion.answerConfig?.rowTitleArray,
            answerConfigArray: currentAnswerConfigArray,
            resultType: getters.currentResultType,
          };
          // 检查当前题目的答案是否已经在resultList中
          const existingResult = tempResultList.find(
            (item) => item.titleId === currentQuestion.titleConfig.id
          );
          if (!existingResult) {
            tempResultList.push(tempCurrentResult);
          } else {
            // 如果已存在，更新为当前答案
            const index = tempResultList.indexOf(existingResult);
            tempResultList[index] = tempCurrentResult;
          }
        }
        // 基于临时resultList检查关联题目是否应该激活
        const shouldActivate = checkRelationQuestionActivation(
          state.questionList[currentIndex],
          tempResultList,
          state,
          getters
        );
        if (!shouldActivate) {
          // 如果仍然不应该激活，跳过该题
          if (currentIndex === state.questionList.length - 1) {
            // 最后一题
            return -1;
          }
          currentIndex = currentIndex + 1; // 直接递增，避免递归调用
          depth++;
        } else {
          // 如果应该激活，更新激活状态并继续
          break;
        }
      } else {
        break; // 找到有效题目，退出循环
      }
    }

    // 如果达到最大深度仍未找到有效题目，返回 -1
    if (depth >= maxDepth) {
      return -1;
    }

    return currentIndex;
  },
  currentValidQuestionIndex(state, getters) {
    return getters.getValidQuestionIndex(getters.nextQuestionIndex);
  },
  prevQuestionIndex(state) {
    // 计算上一题下标
    // 获取最后一个非空对象的currentIndex
    let validIndex = state.resultList.length - 1;
    if (validIndex === -1) return -1;
    while (
      state.resultList[validIndex] &&
      Object.keys(state.resultList[validIndex]).length === 0
    ) {
      validIndex--;
    }
    return state.currentIndex === 0
      ? -1
      : state.resultList[validIndex]?.currentIndex;
  },
};
